import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLocation,useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";
import { DocumentoComentarioDTO } from "../../../types/documento/comentario/DocumentoComentarioDTO";

import { DocumentoComentario, ISdocumentoComentario } from "../../../types/documento/comentario/DocumentoComentario";
import { useAddDocumentoComentarioMutation, useGetDocumentoComentarioQuery } from "./documentoComentarioApiSlice";

export const DocumentoComentarioCreate = () => {

    const idDocumento = useParams().id || "";
     
        const location = useLocation();
        const params = new URLSearchParams(location.search);
        const idComentario = params.get('idComentario');

    const [documentoComentario, SetDocumentoComentario] = useState<DocumentoComentario>(ISdocumentoComentario);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createComentario, status] = useAddDocumentoComentarioMutation();
    const navigate = useNavigate();

    // Hook para seleção do documento
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);


    //verificar se for edicao ele pega o id e faz a consulta 
    
    const { data, isFetching, error } = useGetDocumentoComentarioQuery(idComentario || "");
    useEffect(() => {
        if (data) {
            SetDocumentoComentario(data);
        }
    }, [data, error, isFetching])





    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        SetDocumentoComentario((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const parms: DocumentoComentarioDTO = {
            id: documentoComentario.id,
            descricao: documentoComentario.descricao,
            documentoID: idDocumento ? idDocumento : "",
        }
        await createComentario(parms);
    }

    useEffect(() => {        

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Comentário(s) do documento: {processoSelecionado?.numeroProcesso}

                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        label="Descricão:"
                                        name="descricao"
                                        onChange={handleChange}
                                        size="small"
                                        inputProps={{ maxLength: 255 }}
                                        value={documentoComentario.descricao}
                                        multiline  // Adiciona o suporte a múltiplas linhas
                                        rows={4} />


                                    <FormHelperText>
                                        {documentoComentario.descricao?.length}/255 caracteres
                                    </FormHelperText>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>
                </Box>
            </Paper>
        </>
    );
};

